var _path, _path2, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParticipantAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,10c-10.798,0-18.181,8.711-16.403,19.365l2.689,16.13C37.351,51.888,43.519,57.116,50,57.116 s12.649-5.229,13.714-11.621l2.689-16.13C68.181,18.711,60.798,10,50,10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.675,64.558l-19.668-6.557c-3.76,3.539-8.736,5.781-14.007,5.781s-10.247-2.242-14.007-5.781l-19.668,6.557 C12.849,65.72,10,69.668,10,73.333V90h80V73.333C90,69.668,87.155,65.72,83.675,64.558z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "90,40 83.333,40 83.333,33.333 76.667,33.333 76.667,40 70,40 70,46.667 76.667,46.667 76.667,53.333  83.333,53.333 83.333,46.667 90,46.667 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantAdd);
export default __webpack_public_path__ + "static/media/participant_add.f8fdb0583e2b0a640adb200665b99acc.svg";
export { ForwardRef as ReactComponent };